import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import TypeCreationSchema from "../../../../Schemas/TypeCreationSchema";

import { createType, updateType } from "../../../../Services/TypeService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function TypeCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
    },
    enableReinitialize: true,
    validationSchema: TypeCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  const handleSubmit = async () => {
    const values = formik.values;
    if (isEmpty(values.name)) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createType(values);
        message.success("Type created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the type list or wherever you want
      } else {
        const updatedType = await updateType(data._id, values);
        callReFetch();
        message.success(
          updatedType?.data?.message || "Type updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "Type Detail" : "Create Type";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama Tidak boleh duplicate
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundType: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter type name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

TypeCreationForm.propTypes = {};

export default TypeCreationForm;
